export enum SkeletonSectionType {
  profilePicture = 'profilePicture',
  tableHeader = 'tableHeader',
  tableRow = 'tableRow',
  nftCard = 'nftCard',
  filter = 'filter',
}
